import { render, staticRenderFns } from "./ActualizarReglaPLMF.vue?vue&type=template&id=55bac86a"
import script from "./ActualizarReglaPLMF.vue?vue&type=script&lang=js"
export * from "./ActualizarReglaPLMF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports